<template>
  <v-card elevation="0">
    <v-list class="branded-background">
    	<v-list-tile avatar>
    	  <v-icon color="white">playlist_play</v-icon>
    	  <v-list-tile-content style="display: flex; flex-flow: row; justify-content:space-between; align-items:center">
    		<v-list-tile-title >
    			<span :class="instructorType === 'free' ? 'text-white text-truncate-popover assign-title-width': 'text-white text-truncate-popover'">Assign {{playlist.name}}</span>
    		</v-list-tile-title>
    		<v-tooltip
    			v-if="instructorType === 'free'"
    			top
    			:z-index="99999999999"
    		>
    			<template slot="activator">
    				<div class="assign-limit">
    					<v-progress-linear
    						no-flex
    						v-model="baPercentage"
    						color="white"
    					></v-progress-linear>
    					<div
    						ref="storageLabel"
    						class="assign-limit-label"
    					>
    						<v-icon
    							v-show="baPercentage >= 90"
    							color="white"
    							small
    							class="mr-1"
    						>
    							warning
    						</v-icon>
    						{{baPercentage}}% of bulb attempts used.
    					</div>
    				</div>
    			</template>
    			<v-layout column justify-center>
    				<v-layout justify-space-between>
    					<div class="text-white">Current bulb attempts used:</div>
    					<div class="text-white" style="padding-left:8px;">{{free.ba_limit}}</div>
    				</v-layout>
    			</v-layout>
    		</v-tooltip>
    	</v-list-tile-content>
     </v-list-tile>
    </v-list>
    <div> 
      <v-tabs grow v-model="assignTabs">
        <v-tab>
          Assign to Course
        </v-tab>
        <v-tab :disabled="assignBroadcast">
          Get Assign Link
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="assignTabs">
        <v-tab-item :key="0">
          <AssignCourse :assignBroadcast="assignBroadcast" :hotlinkAssignLink="hotlinkAssignLink" :assignPlaylist="true" :playlist="playlist"></AssignCourse>
        </v-tab-item>
        <v-tab-item :key="1">
          <PlaylistAssignLink :assignClass="assignClass" :playlist="playlist" :hotlinkAssignCourse="hotlinkAssignCourse" :hotlink="hotlink"></PlaylistAssignLink>
        </v-tab-item>
      <v-divider></v-divider>
        <v-card-actions class="row-space" style="height:56px">
         <v-btn flat class="branded-grey" @click="setDashModal(null)">Close</v-btn>
        </v-card-actions>
      </v-tabs-items>
    </div>
  </v-card>
</template>

<script>
/* global _ */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import AssignCourse from '../assign/AssignCourse';
import PlaylistAssignLink from './PlaylistAssignLink';
import _ from 'lodash';

export default {
  name: 'PlaylistAssign',
  components: {
    AssignCourse,
    PlaylistAssignLink,
  },
  props: [
    'playlist',
    'hotlink',
  ], 
  data() {
    return {
      assignBroadcast: false,
      assignClass: {},
      assignTabs: 0,
    };
  },
  computed: {
    ...mapState('instructors', [
      'playlistAssignedDates',
    ]),
    ...mapGetters([
      'instructorType',
    ]),
    ...mapGetters('instructors', [
      'classes',
      'instructorAjaxing',
      'queryParamsInstructors',
    ]),
  },
  methods: {
    ...mapActions('instructors', [
      'getPlaylistMonitorData',
    ]),
    ...mapMutations([
      'setDashModal',
    ]),
    isPlaylistAssigned(section) {
      return _.find(this.playlistAssignedDates, { 'sectionId': section.id });
    },
    // hotlink functions
    hotlinkAssignCourse() {
      this.$store.dispatch('instructors/getPlaylistMonitorData', this.playlist.id);
      this.assignTabs = 0;
    },
    hotlinkAssignLink(data) {
      this.assignClass = data;
      this.assignTabs = 1;
    }, 
  },
  mounted() {
    this.getPlaylistMonitorData(this.playlist.id);
  },
};
</script>


